(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('it').replace(/[^a-z0-9]+/g, ' ').trim();
  function init(scope = document) {
    scope.querySelectorAll('[data-brand-directory]').forEach(root => {
      if (root.dataset.brandSearchReady) return;
      root.dataset.brandSearchReady = 'true';
      const form = root.querySelector('.ida-brand-search');
      const input = form.querySelector('input');
      const reset = form.querySelector('[data-brand-reset]');
      const status = form.querySelector('[role="status"]');
      const cards = [...root.querySelectorAll('[data-brand-name]')];
      let visible = cards;
      function filter() {
        const query = normalize(input.value);
        const words = query.split(' ').filter(Boolean);
        visible = cards.filter(card => {
          const name = normalize(card.dataset.brandName);
          const matches = words.every(word => name.includes(word));
          card.hidden = !matches;
          if (query && matches) card.classList.remove('scroll-trigger', 'animate--slide-in');
          return matches;
        });
        reset.hidden = !input.value;
        status.textContent = !query ? '' : visible.length === 0 ? 'Nessun brand trovato. Prova un altro nome.' : visible.length === 1 ? '1 brand trovato · premi Invio per scoprirlo.' : `${visible.length} brand trovati`;
      }
      form.hidden = false;
      input.addEventListener('input', filter);
      input.addEventListener('search', filter);
      reset.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (normalize(input.value) && visible.length === 1) window.location.assign(visible[0].querySelector('a').href);
      });
      filter();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
